import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)

import VDeals from './VDeals/VDeals.vue'

Vue.customElement('v-deals', VDeals)
